import React from 'react';
import axios from 'axios';
import { API_KEY_ACCOUNTS, GET_USER_ATTRIBUTES } from '../../constants';

export default Component => ({ businessId, ...others }) => {
  const [userAttributes, setUserAttributes] = React.useState({});
  const getUserInfo = async () => {
    const token = localStorage.getItem('accessToken');
    try {
      const response = await axios({
        method: 'get',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': `${API_KEY_ACCOUNTS}`,
          Authorization: `Bearer ${token}`,
        },
        url: `${GET_USER_ATTRIBUTES}/${businessId}`,
        validateStatus(status) {
          return status === 200; // default
        },
      });
      // console.log('Response', response.data);
      if (response.data.UserAttributes) {
        const attrs = {};
        response.data.UserAttributes.forEach(attribute => {
          attrs[attribute.Name] = attribute.Value;
        });
        setUserAttributes(attrs);
      }

      return response.data;
    } catch (err) {
      throw err;
    }
  };
  React.useEffect(() => {
    getUserInfo();
  }, []);
  // console.log('BusId', businessId);
  // console.log('BusIdAtte', userAttributes);
  return <Component userAttributes={userAttributes} {...others} />;
};
